import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { PAYMENT_PROTECTION_INSURANCE_LINKS } from '@/constants/SE/PaymentProtectionInsurance';
import Button from '@/ui-kit/components/Button/Button';

const PaymentProtectionInsuranceTerms = ({ closeModal, confirmAction = closeModal }: ModalProps) => {
  const { t } = useTranslation('Button');

  return (
    <Modal title="Krav för betalskyddet">
      <p>Fairlo Betalskydd passar dig som är privatperson och som:</p>
      <ul>
        <li>Har en aktiv kontokredit hos Fairlo utan likvärdigt betalskydd.</li>
        <li>Är stadigvarande bosatt i Sverige vid tecknandet av försäkringen.</li>
        <li>Uppfyller någon av nedananstående:</li>
      </ul>
      <h2 className="text-body-semibold">För anställda</h2>
      <ul>
        <li>
          Du har en tillsvidareanställning och denna har pågått i minst tre sammanhängande månader före
          tecknandet av försäkringen, utan att det föreligger en verkställd uppsägning.
        </li>
        <li>Det föreligger ingen varsel om permittering eller verkställd permittering.</li>
        <li>
          Din arbetsgivare tar inte emot statligt stöd för anställningen enligt lag (2013:948) om stöd vid
          korttidsarbete.
        </li>
        <li>
          Du är fullt arbetsför och får inte sjukpenning, sjukersättning, a-kassa, aktivitetsersättning eller
          liknande.
        </li>
        <li>Du är inskriven i svensk försäkringskassa och ansluten till en erkänd svensk a-kassa.</li>
      </ul>
      <h2 className="text-body-semibold">För egenföretagare</h2>
      <ul>
        <li>Du driver eget företag.</li>
        <li>
          Du är fullt arbetsför och tar inte emot sjukpenning, sjukersättning, a-kassa, aktivitetsersättning
          eller liknande.
        </li>
        <li>Du är inte inlagd på sjukhus eller vistas på annan ort till följd av läkares inrådan.</li>
      </ul>
      <h2 className="text-body-semibold">För pensionärer</h2>
      <ul>
        <li>Du är ålderspensionär, förtidspensionär eller sjukpensionär.</li>
        <li>Du är inte inlagd på sjukhus eller vistas på annan ort till följd av läkares inrådan.</li>
      </ul>

      <p>
        Bekräftar att jag tagit del av premien, uppfyller kraven för att teckna försäkringen (Vem kan teckna
        betalskyddet?) samt tagit del av{' '}
        <a
          href={PAYMENT_PROTECTION_INSURANCE_LINKS.productFactSheet}
          target="_blank"
          rel="noreferrer"
          className="link"
        >
          produktfaktablad
        </a>
        ,{' '}
        <a
          href={PAYMENT_PROTECTION_INSURANCE_LINKS.prePostPurchaseInfo}
          target="_blank"
          rel="noreferrer"
          className="link"
        >
          för- & efterköpsinformation
        </a>
        ,{' '}
        <a
          href={PAYMENT_PROTECTION_INSURANCE_LINKS.insuranceMediationInfo}
          target="_blank"
          rel="noreferrer"
          className="link"
        >
          information om försäkringsförmedling
        </a>
        , godkänner de{' '}
        <a
          href={PAYMENT_PROTECTION_INSURANCE_LINKS.fullTerms}
          target="_blank"
          rel="noreferrer"
          className="link"
        >
          fullständiga villkor
        </a>{' '}
        för betalskyddet och accepterar att få försäkringsinformationen digitalt.
      </p>

      <ModalActions>
        <Button onClick={confirmAction}>{t('close')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default PaymentProtectionInsuranceTerms;
